export default __webpack_public_path__ + "521b6574070f8df0e7763e9472769f89.svg";